'use strict';

frontendApp.controller('LoadFileCtrl', ['$rootScope', '$scope', '$route', '$routeParams', '$uibModal', '$location', '$timeout', '$filter', 'ProjectService', 'OrganizationService', 'CollectionService', 'ExportService', 'CustodianService', 'ConfigService', 'TagCategoryService', 'NotificationService', 'NavigationService', 'LoadFileService', 'HttpService', function($rootScope, $scope, $route, $routeParams, $uibModal, $location, $timeout, $filter, ProjectService, OrganizationService, CollectionService, ExportService, CustodianService, ConfigService, TagCategoryService, NotificationService, NavigationService, LoadFileService, HttpService) {

    NavigationService.setActiveTab('projects');

    $scope.project = ProjectService.findOne($routeParams.projectId, function(project) {
        $scope.project = project;

        if (project.type == 'organization_project') {
            $scope.organization = OrganizationService.findOne(project.organizationId);
        }
        ProjectService.SetCurrentProject(project);
    });

    $scope.loadFile = {
        projectId: "",
        source: ""
    };

    $scope.$on('fileDropped', function(evt, file) {
        $scope.fileToUpload = file;
        $scope.loadFile.source = file.name;
    });

    $scope.$on('droppedFileRemoved', function(evt) {
        $scope.fileToUpload = null;
        $scope.loadFile.source = "";
    });

    $scope.saveLoadFile = function(loadFile) {

        /*
        var newLoadFile = LoadFileService.create(
            loadFile.projectId,
            loadFile.source
        );
        */

        $scope.uploading = true;

        var url = ConfigService.getServerBaseUrl() +
            "/project/" +
            $scope.project.id +
            "/loadFile";

        var formData = new FormData();
        formData.append('file', $scope.fileToUpload);

        $scope.uploadProgress = 0;
        $scope.uploadBytesLoaded = 0;
        $scope.uploadBytesTotal = 0;

        // TODO: Dear god i need to make this all a directive.
        HttpService.$ajax(url, {
            type: 'POST',
            data: formData,
            cache:false,
            processData: false,
            contentType: false,
            xhr: function() {
                var myXhr = $.ajaxSettings.xhr();
                if (myXhr.upload) {
                    myXhr.upload.addEventListener('progress',function(ev) {
                        if (ev.lengthComputable) {
                            var percentUploaded = Math.floor(ev.loaded * 100 / ev.total);

                            $scope.$apply(function() {
                                $scope.uploadBytesLoaded = ev.loaded;
                                $scope.uploadBytesTotal = ev.total;
                                $scope.uploadProgress = percentUploaded;
                            });
                        }
                    }, false);
                }
                return myXhr;
            },
            success: function () {
                $scope.$apply(function() {
                    $scope.uploading = false;

                    NotificationService.addSuccess({
                        title: 'Load File added succesfully',
                        description: 'We are now processing your file',
                        timeout: 5000
                    });
                });
            },
            error: function() {
                $scope.$apply(function() {
                    $scope.uploading = false;

                    NotificationService.addError({
                        title: 'Error uploading Load File',
                        description: "That's embarrassing, please try again later",
                        timeout: 5000
                    });
                })
            }
        });

    };


}]);
